import type {
  ManagingPromptActionPrefill,
  ManagingPromptActionType,
  QuillDelta,
} from "../types/chat.types";

export interface CrmActionEmbedData {
  type: ManagingPromptActionType;
  label: string;
  prefill?: ManagingPromptActionPrefill;
}

export function deltaHasInlineCrmActions(delta?: QuillDelta | null): boolean {
  if (!delta?.ops?.length) {
    return false;
  }
  return delta.ops.some((op) => {
    const insert = op.insert;
    return (
      insert !== null &&
      typeof insert === "object" &&
      !Array.isArray(insert) &&
      "crm-action" in (insert as Record<string, unknown>)
    );
  });
}

export function parseCrmActionEmbed(value: unknown): CrmActionEmbedData | null {
  if (!value || typeof value !== "object") {
    return null;
  }
  const obj = value as Record<string, unknown>;
  const type = obj.type;
  if (typeof type !== "string") {
    return null;
  }
  const label = typeof obj.label === "string" ? obj.label : type;
  const prefill = obj.prefill as ManagingPromptActionPrefill | undefined;
  return { type: type as ManagingPromptActionType, label, prefill };
}
